import { W, H, R } from "./props";

export const WATCHER_DURATION = 13;
export const WATCHER_STING = 4;
const CAPTIONS = [
  [0.6, 3.4, "The cave breathes cold air. Joe can't make himself go in."],
  [3.8, 6.6, "Then he sees it. Up on the ridge. A figure in a red cloak."],
  [7.0, 9.6, "It doesn't move. It just watches him."],
  [10.0, 12.5, "The torch goes out. Joe runs."],
];
export const watcherCaption = (tt) => (CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;

function figure(ctx, x, y, t, lit) {
  const sway = Math.round(Math.sin(t / 900));
  R(ctx, "#5c0f0f", x + sway, y - 14, 6, 14); R(ctx, "#7f1d1d", x + 1 + sway, y - 14, 4, 14);
  R(ctx, "#5c0f0f", x + 1 + sway, y - 18, 4, 5); R(ctx, "#050203", x + 2 + sway, y - 16, 2, 2);
  R(ctx, "#2a160a", x + 7, y - 20, 1, 12);
  if (lit) {
    const f = Math.abs(Math.sin(t / 90)) * 2;
    const g = ctx.createRadialGradient(x + 7, y - 22, 0, x + 7, y - 22, 26);
    g.addColorStop(0, "rgba(249,115,22,0.45)"); g.addColorStop(1, "rgba(249,115,22,0)");
    ctx.fillStyle = g; ctx.fillRect(x - 20, y - 48, 54, 54);
    R(ctx, "#f97316", x + 6, y - 23 - f, 3, 3 + f); R(ctx, "#fde047", x + 7, y - 22, 1, 2);
  }
}

export function drawWatcher(ctx, tt, now) {
  R(ctx, "#03050b", 0, 0, W, H);
  for (let s = 0; s < 80; s++) R(ctx, "#0a1222", 150 + s * 2, 40 + Math.abs(s - 40) * 1.1, 2, H);
  R(ctx, "#a9bbcc", 220, 40, 20, 2);
  for (let i = 0; i < 9; i++) { const x = 160 + i * 18; R(ctx, "#05080f", x + 4, 74, 2, 20); R(ctx, "#060a12", x + 1, 66, 8, 10); }
  R(ctx, "#1a2230", 0, 126, W, H - 126); R(ctx, "#8ea4bb", 0, 124, W, 3);
  R(ctx, "#20252c", 0, 0, 92, H); R(ctx, "#2b3038", 84, 0, 14, H); R(ctx, "#d9e4ee", 84, 0, 3, H);
  R(ctx, "#20252c", 0, 0, W, 14);
  for (let i = 0; i < 18; i++) R(ctx, "#cfe3f2", 96 + i * 12, 14, 2, 3 + (i * 7) % 6);
  const lit = tt < 10;
  if (tt > 3.6) figure(ctx, 236, 74, now, lit);
  else if (Math.sin(now / 120) > 0.95) R(ctx, "#7f1d1d", 238, 62, 1, 1);
  const shake = tt > 10 ? Math.round(Math.sin(now / 30) * 2) : 0;
  R(ctx, "#020203", 120 + shake, 128, 8, 26); R(ctx, "#020203", 121 + shake, 120, 6, 8); R(ctx, "#020203", 118 + shake, 132, 2, 12); R(ctx, "#020203", 128 + shake, 132, 2, 12);
  for (let i = 0; i < 90; i++) R(ctx, "#cbd5e1", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.02) % H, 1, 1);
  const v = ctx.createRadialGradient(W / 2, H / 2, 60, W / 2, H / 2, 200);
  v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,0.8)"); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > WATCHER_DURATION - 1 ? tt - (WATCHER_DURATION - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
